/**
 *
 * @param user
 */
export function tenantFromUser(user) {
  return user && user[process.env.NEXT_PUBLIC_AUTH0_TENANT_CLAIM];
}

/**
 *
 * @param user
 */
export function nameFromUser(user) {
  const metadata = user && user[process.env.NEXT_PUBLIC_AUTH0_METADATA_CLAIM];
  return {
    firstName: metadata && metadata.firstname,
    lastName: metadata && metadata.lastname,
  };
}
